module.exports = __webpack_public_path__ + "img/Active RA (Golden Circle).77c8c769.svg";